import { createBrowserHistory } from 'history';

const makeHistory = () => {
  return createBrowserHistory();
};

export const history = makeHistory();
